import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DocUploadModal, LIPScreen } from 'fmc-digital-originations';
import { auth, config } from '../../../config';
import { WidgetContentContainer, WidgetContentContainerBg } from '@app.styled';
import { NEW_LOAN_IN_PROGRESS_WIDGETS } from '@utils/appConstants';
import { dispatch } from '@store';
import { useSelector } from 'react-redux';
import { setESIGNDISCLOSEDACTIVEUSER, setESIGNPOPUPSTATUS, setParentModal } from '@store/actions/lip.action';
import { selectEsignPopUpState, selectSelctedDisclosureUser } from '@store/selectors/lip.selector';
import { ContextProvider, setAdditionalProperties } from 'fmc-digital-common';
import AlertModal from '@components/AlertModal/AlertModal';
import {
    selectHasServicingLoan,
    selectLoan,
    selectLoanNumberSelected,
    selectLoanStatusByLoanNumberV2,
    selectNLIPWidgetsList
} from '@store/selectors/widgets.selectors';
import { CodingConstants } from '@constants';
import { setOfferTypeSelected } from '@store/actions/widgets.actions';
import { Identifier } from '@types';
import { Confetti } from '@components/Confetti/Confetti';
import { getLipNTBFeatureFlag } from '@store/reducers/config.reducer';
import { useLocation, useNavigate } from 'react-router-dom';
import { withHeaderFooter } from '../../HOCs';
import { NewLoanInProgressNavigationProps } from '../../data';

export const MigratedLipV2 = withHeaderFooter(
    () => {
        const navigate = useNavigate();
        const loanNumber = useSelector(selectLoanNumberSelected);
        const { state: routeState } = useLocation();
        const [showUploadModalWeb, setShowUploadModalWeb] = useState(false);
        const token = auth.getOkta().getAccessToken();
        const selfServUrl = config.env('selfServUrl');
        const xApiKey = config.env('xApiKey');
        const status: string = useSelector(selectEsignPopUpState);
        const selctedDisclosureUser = useSelector(selectSelctedDisclosureUser);
        const [isEsignUpdating, setEsignUpdating] = useState<boolean>(false);
        const hasServicingLoan: boolean = useSelector(selectHasServicingLoan);
        const loanOptions: Identifier[] = useSelector(selectLoan);
        const [isConfettiNeeded, setIsConfettiNeeded] = useState(false);
        const isNtbRequired = useSelector(getLipNTBFeatureFlag);
        //new coding
        const nlpWidgetList = useSelector(selectNLIPWidgetsList);
        const loanStatus = useSelector(selectLoanStatusByLoanNumberV2);
        const widgets = useMemo(() => {
            return NEW_LOAN_IN_PROGRESS_WIDGETS.map(cWidgetName => {
                return nlpWidgetList.includes(cWidgetName) ? cWidgetName : null;
            }).filter(Boolean);
        }, [nlpWidgetList]);

        const props2: any = {
            loanNumber,
            authToken: token,
            widgets,
            selfServUrl: selfServUrl,
            xApiKey: xApiKey,
            loanStatus,
            isNtbRequired
        };

        useEffect(() => {
            if (status === 'closed') {
                setEsignUpdating(true);
            }
        }, [status]);
        useEffect(() => {
            setAdditionalProperties('isNtbRequired', isNtbRequired);
            setAdditionalProperties('amplify', { loanNumber });
        }, [isNtbRequired, loanNumber]);

        const handleTokenResponse = useCallback((token: string, url: string, userName: string) => {
            dispatch(setParentModal({ showModal: true, component: 'esign', payload: { token, url } }));
            navigate('/e-sign');
            dispatch(setESIGNDISCLOSEDACTIVEUSER(userName));
            dispatch(setESIGNPOPUPSTATUS('opened'));
        }, []);

        const returnToHome = () => {
            dispatch(setOfferTypeSelected(undefined));
            const options = loanOptions?.filter(option => option.type == CodingConstants.servicingLoanType);
            if (options && options?.length > 0) {
                navigate('/', { preventScrollReset: true });
            }
        };

        const handleShowconfetti = useCallback(
            (status: string) => {
                if (status && status === 'Closing') {
                    if (isConfettiNeeded) {
                        setIsConfettiNeeded(false);
                    }
                    setTimeout(() => {
                        setIsConfettiNeeded(true);
                    }, 1000);
                }
            },
            [isConfettiNeeded]
        );

        return (
            <ContextProvider>
                <WidgetContentContainer>
                    <WidgetContentContainerBg>
                        {isConfettiNeeded ? <Confetti /> : undefined}
                        {showUploadModalWeb && (
                            <AlertModal showHeaderWrapper={false} maxWidth="auto">
                                <ContextProvider>
                                    <DocUploadModal />
                                </ContextProvider>
                            </AlertModal>
                        )}
                        <LIPScreen
                            {...props2}
                            handleOnTokenResponse={handleTokenResponse}
                            setShowUploadModalWeb={setShowUploadModalWeb}
                            activeDisclosedUserName={selctedDisclosureUser}
                            isEsignUpdating={isEsignUpdating}
                            setEsignUpdating={setEsignUpdating}
                            isAllowReturnToHome={hasServicingLoan}
                            onReturnToHome={returnToHome}
                            onGetInProgressStatus={handleShowconfetti}
                        />
                    </WidgetContentContainerBg>
                </WidgetContentContainer>
            </ContextProvider>
        );
    },
    { ...NewLoanInProgressNavigationProps }
);
